import { useState, useContext, useEffect } from "react";
import {
  Grid,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemButton,
  Divider,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import request from "../../../utilities/requests";
import { EventContext } from "../../../contexts/EventContext";
import { toast } from "../../../utilities/SnackBarUtils";

const BulkTransferDialog = ({ open, close }) => {
  const { pairingEvent } = useContext(EventContext);
  const [canTransfer, setCanTransfer] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [transferCheckIn, setTransferCheckin] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (open && pairingEvent?.event?.status === "completed") {
      setCanTransfer(true);
      getPairingEvents();
    }
  }, [open]);

  const getPairingEvents = async () => {
    const result = await request("pairingevent");

    if (result.success) {
      const pEvents = result.pairingEvents
        .map((e) => e.event)
        .filter((e) => e._id !== pairingEvent.event._id);
      setEvents(pEvents);
    }
  };

  const formatDate = (date) => {
    try {
      return date.split("T")[0];
    } catch (e) {
      return date;
    }
  };

  const handleTransfer = async () => {
    const body = {
      fromEventId: pairingEvent.event._id,
      toEventId: selectedEvent._id,
      transferCheckIn,
    };
    const result = await request("events/transferattendees", "post", body);
    if (result.success) {
      toast.success("Attendees transferred successfully");
      handleClose();
    }
  };

  const handleClose = () => {
    setEvents([]);
    setSelectedEvent(null);
    setCanTransfer(false);
    close();
  };

  if (!canTransfer) {
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {"Transfer Attendees"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You can only transfer attendees to another event once this event is
            complete.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Got It</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">{"Transfer Attendees"}</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Typography>
            {" "}
            Select an event to which you would like to transfer attendees
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={transferCheckIn}
                onChange={() => setTransferCheckin(!transferCheckIn)}
              />
            }
            label="Transfer check in status"
          />
          <List>
            {events.map((event) => {
              return (
                <div key={event._id}>
                  <ListItem>
                    <ListItemButton
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSelectedEvent(event);
                        setShowConfirm(true);
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {event?.name}
                      </Typography>
                      <Typography variant="body2">
                        {formatDate(event?.date)}
                      </Typography>
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
      <Dialog open={showConfirm}>
        <DialogTitle>Confirm Transfer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to transfer all attendees to{" "}
            {selectedEvent?.name}? This cannot be undone!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTransfer}>confirm</Button>
          <Button onClick={() => setShowConfirm(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default BulkTransferDialog;
